// extracted by mini-css-extract-plugin
export default {"main":"Home_main__19nnz","pageBtn":"Home_pageBtn__l69oa","updateDiv":"Home_updateDiv__4Burm"};